<template>
    <div>
        <SignaturesPane />
    </div>
</template>

<script>
    import SignaturesPane from '../Core/RecordComponents/SignaturesPane.vue';

    export default {
        name: "EmbedSignaturesPane",
        props: [

        ],
        data: function () {
            return {
                
            }
        },
        methods: {
            
        },
        components: {
            SignaturesPane
        },
        computed: {
        },
    }
</script>